import {
  getSelectedCompanyIds,
  setSelectedCompanyIds,
  readActiveProjectId,
  readActiveCompanySession,
} from "./workspaceStorage";

export { getSelectedCompanyIds, setSelectedCompanyIds };

function readNumericCompanyLocalStorage() {
  try {
    const c = typeof localStorage !== "undefined" ? localStorage.getItem("company") : null;
    if (c && /^\d+$/.test(String(c).trim())) {
      const n = parseInt(c, 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * id_projeto para GET /setup/snapshot e escopo de etapas — alinha workspace "ativo" às empresas selecionadas.
 */
export function resolveSnapshotProjectId(savedProjectIdFromSetup) {
  if (
    savedProjectIdFromSetup != null &&
    Number.isFinite(Number(savedProjectIdFromSetup)) &&
    Number(savedProjectIdFromSetup) > 0
  ) {
    return Number(savedProjectIdFromSetup);
  }
  const selected = getSelectedCompanyIds();
  try {
    const ac = readActiveCompanySession();
    const n =
      ac != null && /^\d+$/.test(String(ac).trim()) ? parseInt(String(ac).trim(), 10) : NaN;
    if (Number.isFinite(n) && n > 0 && selected.includes(n)) return n;
  } catch {
    /* ignore */
  }
  const active = readActiveProjectId();
  if (active && selected.includes(active)) return active;
  if (selected.length) return selected[0];
  if (active) return active;
  return readNumericCompanyLocalStorage();
}

/** Primeiro id_projeto selecionado no painel, para ?id_projeto / política de idioma. */
export function readPrimaryProjectId() {
  const selected = getSelectedCompanyIds();
  if (selected.length) return selected[0];
  return null;
}

/** Empresa ativa/selecionada no seletor — usada pelos simuladores de chatbot e agente. */
export function resolveSimulationProjectId() {
  return resolveSnapshotProjectId(null);
}
